import { edituser, getAllUsers, saveuser } from '@/services/users/usersService';
import { createModel } from '@rematch/core';

const initialState: {} = {
	isloaded: false,
	users: [],
	usersList: [],
	edituser: {},
	addmode: true,
	categoriesbypost: []
}
export const userModel = createModel()({
	state: { ...initialState },
	reducers: {

		UPDATE: (state, key, value) => {

			return {
				...state,
				[key]: value,
			};
		},
		setUsers(state, res) {
			return {
				...state,
				users: res.data,
			};
		}, setuseredit(state, res) {
			return {
				...state,
				edituser: res,
			};
		}, setUsersList(state, res) {
			return {
				...state,
				usersList: res,
			};
		},
		setaddmode(state, res) {
			return {
				...state,
				addmode: res,
			};
		},




	},
	effects: (dispatch) => ({

		async getusers() {
			const response = await getAllUsers();
			if (response) {
				// console.log(response)
				this.setUsers({ data: response })
				return response
			} else {
				this.setUsers({ response: [] })
				return {}
			}

		},



		async saveuser(x) {
			const response = await saveuser(x);
			if (response) {
				// console.log(response)
				this.setUsersList({ option: response.data })
				return response
			} else {
				this.setUsers({ response: [] })
				return {}
			}

		},
		async edituser(x) {
			const response = await edituser(x);
			if (response) {
				// console.log(response)
				this.setUsersList({ option: response.data })
				return response
			} else {
				this.setUsers({ response: [] })
				return {}
			}

		},




	}),

})